import { render } from "./admin.vue?vue&type=template&id=4bef2bde"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"
script.render = render

export default script